<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// This replaces the old manual JSON parsing + lazy fallbacks pattern
// If config is invalid, parseAndValidateConverterConfig() throws with detailed error
// NOTE: jobCategory, labels, and creditCost are now provided by backend
const converterConfig = parseAndValidateConverterConfig('doc-to-pdfa-converter', 'DOC → PDF/A');

// Event handlers (optional - for DOCX PDF/A-specific analytics or side effects)
function handleBatchCreated(batchId: string) {
  console.log('[DOCX to PDF/A Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[DOCX to PDF/A Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[DOCX to PDF/A Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[DOCX to PDF/A Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[DOCX to PDF/A Converter] Credits updated:', credits);
}
</script>
